import React from "react";
import { Chip, Group, Text } from '@mantine/core';

const CustomerCategorySelectorSingle = ({
    stateValue = '',
    fnOnChange,
    stateData = [],
    stateDataLoading = false,
    stateDataFlag = 'idle',
}) => {
    return (
        <React.Fragment>
            {(Array.isArray(stateData) && (stateData.length > 0) && !stateDataLoading && stateDataFlag !== 'idle') &&
                <Chip.Group
                    value={stateValue}
                    onChange={fnOnChange}
                >
                    <Group spacing='xs'>
                        {Array.isArray(stateData) && Object.keys(stateData).map((keyCC, indexCC) => {
                            return (
                                <Chip
                                    key={keyCC}
                                    value={String(stateData[keyCC].customer_category_slug)}
                                    radius='sm'
                                >
                                    {stateData[keyCC].customer_category_name}
                                </Chip>
                            )
                        })}
                    </Group>
                </Chip.Group>
            }

            {(Array.isArray(stateData) && (stateData.length <= 0) && !stateDataLoading && stateDataFlag !== 'idle') &&
                <Text color="dimmed" size='sm' fs='italic'>Tidak ada data kategori customer</Text>
            }

            {stateDataLoading &&
                <Text color="dimmed" size='sm' fs='italic'>Loading kategori customer...</Text>
            }
        </React.Fragment>
    )
}

export default CustomerCategorySelectorSingle;